import { render, staticRenderFns } from "./PopupDisplayItem.vue?vue&type=template&id=6237659a&scoped=true&lang=pug&"
import script from "./PopupDisplayItem.vue?vue&type=script&lang=coffee&"
export * from "./PopupDisplayItem.vue?vue&type=script&lang=coffee&"
import style0 from "./PopupDisplayItem.vue?vue&type=style&index=0&id=6237659a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6237659a",
  null
  
)

export default component.exports